import { cn } from '@thinkalpha/ui-core/utils';
import type { HTMLAttributes } from 'react';

export const WidgetHeaderElementLabel = ({ children, className, ...restProps }: HTMLAttributes<HTMLSpanElement>) => {
    return (
        <span className={cn('inline-block min-w-max', className)} {...restProps}>
            {children}
        </span>
    );
};
